<template>
  <v-app-bar app color="#424949" dark>
    <v-img
      v-if="$store.state.idInstitucion === 410"
      src="../../assets/cotLogo.jpeg"
      max-height="50"
      max-width="150"
      contain
    ></v-img>
    <a v-else href="//www.sigemed.com.ar"
      ><v-img
        src="../../assets/isologo.png"
        max-height="50"
        max-width="150"
        contain
      ></v-img
    ></a>

    <!-- <v-toolbar-title>GesMed</v-toolbar-title> -->

    <v-spacer></v-spacer>

    <v-btn icon :href="facebookUrl" target="_blank">
      <v-icon>mdi-facebook</v-icon>
    </v-btn>

    <v-btn
      v-if="$store.state.idInstitucion !== 410"
      icon
      href="https://www.instagram.com/sigemedok/"
      target="_blank"
    >
      <v-icon>mdi-instagram</v-icon>
    </v-btn>
  </v-app-bar>
</template>
<script>
export default {
  computed: {
    facebookUrl() {
      return this.$store.state.idInstitucion === 410
        ? "https://www.facebook.com/cotbahia"
        : "https://www.facebook.com/sigemed/";
    },
  },
};
</script>
